export default {
  getAllDomainOptions: ({ filters }) => (filters.domains.all.map(domain => ({ value: domain.domainId, text: domain.domainName }))),
  getAllConfigKeyOptions: ({ filters }) => (filters.configKeys.all.map(configKey => ({ value: configKey, text: configKey }))),
  getConfigKeyOptionsByDomain: ({ filters }) => domainId => (filters.domains[domainId].map(configKey => ({ value: configKey, text: configKey }))),
  getDomainOptionsByConfigKey: ({ filters }) => configKey => filters.configKeys[configKey].map(domain => ({ value: domain.domainId, text: domain.domainName })),
};
